import React, { useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import "./Stats.css";
import { scrollToSection } from "../../../utils/scroll";
import { handleSectionNavigation } from "../../../utils/navigation";
import { animateCounter } from "../../../utils/counter";
import { FiArrowRight } from "react-icons/fi";

const Stats = ({ onNavigate }) => {
  const navigate = useNavigate();
  const statsRef = useRef(null);

  const statsData = [
    {
      value: 10,
      suffix: "+",
      label: "Anos no Mercado",
      description: "Experiência de sobra",
    },
    {
      value: 25000,
      suffix: "+",
      label: "Clientes Atendidos",
      description: "Pessoas transformadas",
    },
    {
      value: 18,
      prefix: "R$ ",
      suffix: " mi+",
      label: "Em Operações",
      description: "Crescendo sem parar",
    },
    {
      value: 10,
      suffix: "+",
      label: "Parceiros",
      description: "Evoluindo juntos",
    },
  ];

  useEffect(() => {
    const element = statsRef.current;

    if (!element) return;

    const observer = new IntersectionObserver(
      ([entry]) => {
        if (!entry.isIntersecting) return;

        element.querySelectorAll(".stat-number").forEach((number) => {
          const value = Number(number.dataset.value);
          const prefix = number.dataset.prefix || "";
          const suffix = number.dataset.suffix || "";

          animateCounter(
            number,
            value,
            1500,
            (currentValue) =>
              `${prefix}${currentValue.toLocaleString("pt-BR")}${suffix}`
          );
        });

        observer.disconnect();
      },
      { threshold: 0.25 }
    );

    observer.observe(element);

    return () => observer.disconnect();
  }, []);

  const handleNavigation = (e, id) => {
    handleSectionNavigation(
      e,
      id,
      navigate,
      scrollToSection,
      onNavigate
    );
  };

  return (
    <section id="dados" className="section stats" ref={statsRef}>
      <div className="container">

        <div className="stats-head">
          <h1 className="title">
            Números que <br className="mobile-break" />
            Falam por Si
          </h1>

          <p className="subtitle">
            Mais de uma década de experiência transformando sonhos em
            realidade através de soluções financeiras inteligentes e
            personalizadas.
          </p>
        </div>

        <div className="stats-grid">
          {statsData.map((stat, index) => (
            <div className="stat" key={index}>

              <div
                className="stat-number"
                data-value={stat.value}
                data-prefix={stat.prefix || ""}
                data-suffix={stat.suffix || ""}
              >
                {stat.prefix || ""}
                0
                {stat.suffix || ""}
              </div>

              <div className="stat-label">
                {stat.label}
              </div>

              <div className="stat-description">
                {stat.description}
              </div>

            </div>
          ))}
        </div>

        <div className="stats-cta">
          <a
            href="#contato"
            className="btn btn-primary"
            onClick={(e) => handleNavigation(e, "contato")}
          >
            <span>Nos conte sua história!</span>
            <FiArrowRight size={16} />
          </a>
        </div>

      </div>
    </section>
  );
};

export default Stats;